module.exports = __webpack_public_path__ + "media/images/cplook/ajax-loader-92cd79afeef21c8fb6ab160292e5e6a8.gif";